import web from "../web";

class DevoirsService {
    index(token){
        return web.get("/api/devoirs", { headers: { 'Authorization': 'Bearer '+token } })
    }
    store(data, token){
        return web.post("/api/devoirs", data, { headers: { 'Authorization': 'Bearer '+token } })
    }

    show(id,token){
        return web.get(`/api/devoirs/${id}/show`,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    update(data,token){
        return web.put("/api/devoirs/update", data, { headers: { 'Authorization': 'Bearer '+token } })
    }

    delete(id,token){
        return web.delete(`/api/devoirs/${id}/delete`,{ headers: { 'Authorization': 'Bearer '+token } })
    }
}

export default new DevoirsService()